var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainLayout',{staticClass:"ranking white pt-4"},[_c('GlobalRanking',{attrs:{"background":"white"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }